export default __webpack_public_path__ + "static/media/0xdd2af2e723547088d3846841fbdcc6a8093313d6.a3b87c84.webp";